import {
  useApprovalListLazyQuery,
  useDcRequestsListQuery,
} from "generated/graphql"
import { useSearchFilter } from "hooks/searchFilterHooks"
import { useEffect } from "react"
import { useParams } from "react-router-dom"

export const useApprovalRequestsList = () => {
  const [{ date, search, page, type }] = useSearchFilter()
  const [getRequests, response] = useApprovalListLazyQuery()

  let filter: any = {
    isSku: false,
    excludeItemCategory: [6],
  }

  if (type === "rpg") {
    filter = {
      isSku: true,
    }
  }

  if (type === "raw-material") {
    filter = {
      isSku: false,
      includeItemCategory: [6],
    }
  }

  useEffect(() => {
    getRequests({
      variables: {
        first: 15,
        skip: page * 15,
        query: search,
        filter: { ...filter, addedOn: date },
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, getRequests, search, page, type])
  return response
}

export const useDCRequestsList = () => {
  const [{ date, type, view }] = useSearchFilter()
  const { id } = useParams<{ id: string }>()

  let filter: any = {
    isSku: false,
    excludeItemCategory: [6],
  }

  if (type === "rpg") {
    filter = {
      isSku: true,
    }
  }

  if (type === "raw-material") {
    filter = {
      isSku: false,
      includeItemCategory: [6],
    }
  }

  const { data, loading, refetch } = useDcRequestsListQuery({
    variables: {
      filter: {
        ...filter,
        addedOn: date,
        distributionCentreId: parseInt(id),
        status: view === "history" ? ["APR", "AUD", "REJ"] : ["PEN"],
      },
    },
  })

  return { data, loading, refetch }
}
